import { render, staticRenderFns } from "./MonitoringClaimShow.vue?vue&type=template&id=2af2ca84&scoped=true&"
import script from "./MonitoringClaimShow.vue?vue&type=script&lang=js&"
export * from "./MonitoringClaimShow.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringClaimShow.vue?vue&type=style&index=0&id=2af2ca84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af2ca84",
  null
  
)

export default component.exports